import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconUpload = ({ color = "var(--color-accent-1)" }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="12" height="12" viewBox="00 00 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.42246 2.60687L5.23496 0.106875C5.17559 0.039375 5.08996 0 4.99996 0C4.90996 0 4.82434 0.039375 4.76496 0.106875L2.57746 2.60687C2.49684 2.69937 2.47684 2.83 2.52809 2.94187C2.57871 3.05312 2.68996 3.125 2.81246 3.125H4.06246V7.1875C4.06246 7.36 4.20246 7.5 4.37496 7.5H5.62496C5.79746 7.5 5.93746 7.36 5.93746 7.1875V3.125H7.18746C7.30996 3.125 7.42121 3.05375 7.47184 2.94187C7.52246 2.83 7.50372 2.69875 7.42246 2.60687Z" fill={color}/>
            <path d="M8.4375 6.875V8.75H1.5625V6.875H0.3125V9.375C0.3125 9.72062 0.5925 10 0.9375 10H9.0625C9.40812 10 9.6875 9.72062 9.6875 9.375V6.875H8.4375Z" fill={color}/>
        </svg>

    </div>
);

export default IconUpload;